import type { Character } from "../api";

/**
 * NarratorPress is what one press of the narrator controls asks the server: a
 * character, and which flag of theirs to set (ADR-0137, ADR-0180).
 */
export type NarratorPress =
  { id: string; narrates: boolean } | { id: string; speaksAlone: boolean };

/**
 * narratorPress is the press of a narrator chip, or of "nobody" (id null).
 * On a one-speaker book a new narrator takes the one speaker with them, since
 * the speaker is the narrator; otherwise only the narrator changes. Clearing
 * the narrator ends a one-speaker book too, which the server does by itself.
 * Null when there is nothing to change.
 */
export function narratorPress(cast: Character[], id: string | null): NarratorPress | null {
  const current = cast.find((c) => c.narrates);
  if (id === null) return current ? { id: current.id, narrates: false } : null;
  if (current?.id === id) return null;
  return current?.speaks_alone ? { id, speaksAlone: true } : { id, narrates: true };
}

/**
 * oneSpeakerPress is the one-speaker switch: on makes the narrator the book's
 * only speaker, off makes it an ordinary book again. Null with no narrator:
 * the switch names who speaks by the narrator chosen above it.
 */
export function oneSpeakerPress(cast: Character[]): NarratorPress | null {
  const current = cast.find((c) => c.narrates);
  return current ? { id: current.id, speaksAlone: !current.speaks_alone } : null;
}
